var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWaitlistSuccess = function SvgWaitlistSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 197,
    viewBox: "0 0 163 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2520_26320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.1 196.3H11.3999V183.3C11.3999 177.3 16.2999 172.4 22.2999 172.4H140.2C146.2 172.4 151.1 177.3 151.1 183.3V196.3Z",
    fill: "#28C2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 0H33.3999V64.3H132.5V0Z",
    fill: "#EAEAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.6 12.5996H68.8V18.9996H117.6V12.5996Z",
    fill: "#C3C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0999 12.5996H48.3999V18.9996H61.0999V12.5996Z",
    fill: "#C3C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.6 28.2002H68.8V34.6002H117.6V28.2002Z",
    fill: "#C3C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0999 28.2002H48.3999V34.6002H61.0999V28.2002Z",
    fill: "#C3C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.6 43.7998H68.8V50.1998H117.6V43.7998Z",
    fill: "#C3C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0999 43.7998H48.3999V50.1998H61.0999V43.7998Z",
    fill: "#C3C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 184.4H16C7.2 184.4 0 177.3 0 168.4V74.7002C0 65.9002 7.10001 58.7002 16 58.7002H147C155.8 58.7002 163 65.8002 163 74.7002V168.4C163 177.2 155.8 184.4 147 184.4Z",
    fill: "#B4EAF0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M132.5 58.7002V66.6002C132.5 70.1002 129.7 72.9002 126.2 72.9002H39.6999C36.1999 72.9002 33.3999 70.1002 33.3999 66.6002V58.7002H132.5Z",
    fill: "#28C2D1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.5 149.687C97.0116 149.687 109.586 137.112 109.586 121.601C109.586 106.089 97.0116 93.5146 81.5 93.5146C65.9884 93.5146 53.4138 106.089 53.4138 121.601C53.4138 137.112 65.9884 149.687 81.5 149.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5001 84.3369C60.9736 84.3369 44.2366 101.074 44.2366 121.6C44.2366 142.127 60.9736 158.864 81.5001 158.864C102.027 158.864 118.764 142.127 118.764 121.6C118.764 101.074 102.027 84.3369 81.5001 84.3369ZM81.5001 152.153C64.6052 152.153 50.8683 138.416 50.8683 121.521C50.8683 104.627 64.6053 90.8897 81.5001 90.8897C98.3949 90.8897 112.132 104.627 112.132 121.521C112.132 138.416 98.395 152.153 81.5001 152.153Z",
    fill: "#FFD590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4999 93.2998V121.6L67.3999 134.4",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2934 133.906C70.4971 133.906 69.6285 133.544 69.0494 132.893C67.8912 131.662 68.036 129.708 69.2666 128.549L78.4598 120.153V101.042C78.4598 99.3773 79.8352 98.002 81.5001 98.002C83.165 98.002 84.5404 99.3774 84.5404 101.042V121.6C84.5404 122.469 84.1785 123.265 83.527 123.844L73.3204 133.182C72.7412 133.689 72.0173 133.906 71.2934 133.906Z",
    fill: "#F7B548"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2520_26320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163,
    height: 196.3,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWaitlistSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/waitlist_success.4d621e4f.svg";